import * as React from "react";
import { forwardRef } from "react";
const SvgCloseSm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9.182 8.333 1.977-1.977a.603.603 0 0 0-.195-.977.6.6 0 0 0-.654.13L8.333 7.486 6.356 5.509a.597.597 0 0 0-.848 0 .603.603 0 0 0 0 .847l1.977 1.977-1.977 1.977a.603.603 0 0 0 .194.978.6.6 0 0 0 .654-.13L8.333 9.18l1.977 1.977a.598.598 0 0 0 1.023-.424.6.6 0 0 0-.174-.424z" }));
const ForwardRef = forwardRef(SvgCloseSm);
export { ForwardRef as ReactComponent };
